import { createContext } from "react";

export type OpenCollectPastDueInvoiceSidebarOptions = {
  invoiceNumber: string;
  userMemberId: string;
  title?: string;
};

interface CollectPastDueInvoiceSidebarProviderContextType {
  openCollectPastDueInvoiceSidebar: (
    values: OpenCollectPastDueInvoiceSidebarOptions,
  ) => void;
}

const defaultContext: CollectPastDueInvoiceSidebarProviderContextType = {
  openCollectPastDueInvoiceSidebar: () => {
    throw new Error(
      "openCollectPastDueInvoiceSidebar function must be used within CollectPastDueInvoiceSidebarProvider",
    );
  },
};

export const CollectPastDueInvoiceSidebarProviderContext =
  createContext<CollectPastDueInvoiceSidebarProviderContextType>(
    defaultContext,
  );
